export const PRODUCT_LIST = "PRODUCT_LIST";
export const PRODUCT_LIST_FAILED = "PRODUCT_LIST_FAILED";
export const PRODUCT_LIST_SUCCESS = "PRODUCT_LIST_SUCCESS";

/*** New Product Arrival  */
export const NEW_PRODUCT_LIST = "NEW_PRODUCT_LIST";
export const NEW_PRODUCT_LIST_FAILED = "NEW_PRODUCT_LIST_FAILED";
export const NEW_PRODUCT_LIST_SUCCESS = "NEW_PRODUCT_LIST_SUCCESS";

/***  Product Detail  */
export const PRODUCT_DETAIL = "PRODUCT_DETAIL";
export const PRODUCT_DETAIL_FAILED = "PRODUCT_DETAIL_FAILED";
export const PRODUCT_DETAIL_SUCCESS = "PRODUCT_DETAIL_SUCCESS";

/***  Product Detail  */
export const PRODUCT_ADDITIONALS = "PRODUCT_ADDITIONALS";
export const PRODUCT_ADDITIONALS_FAILED = "PRODUCT_ADDITIONALS_FAILED";
export const PRODUCT_ADDITIONALS_SUCCESS = "PRODUCT_ADDITIONALS_SUCCESS";

/***  Product Variations  */
export const PRODUCT_VARIATION_DETAIL = " PRODUCT_VARIATION_DETAIL";
export const PRODUCT_VARIATION_DETAIL_FAILED = " PRODUCT_VARIATION_DETAIL_FAILED";
export const PRODUCT_VARIATION_DETAIL_SUCCESS = " PRODUCT_VARIATION_DETAIL_SUCCESS";

/***  Product Filtes  */
export const PRODUCT_FILTERS = "PRODUCT_FILTERS";
export const PRODUCT_FILTERS_FAILED = "PRODUCT_FILTERS_FAILED";
export const PRODUCT_FILTERS_SUCCESS = "PRODUCT_FILTERS_SUCCESS";

/****** Brands List */
export const BRANDS_LIST_SUCCESS = "BRANDS_LIST_SUCCESS";


/***  Product Product Recent Viewed  */
export const PRODUCT_RECENT_VIEWED_ADD = "PRODUCT_RECENT_VIEWED_ADD";
export const PRODUCT_RECENT_VIEWED_LIST = "PRODUCT_RECENT_VIEWED_LIST";
export const PRODUCT_RECENT_VIEWED_FILTER = "PRODUCT_RECENT_VIEWED_FILTER";

/***  Product  Search Viewed  */
export const PRODUCT_SEARCH = "PRODUCT_SEARCH";
export const PRODUCT_SEARCH_SUCCESS = "PRODUCT_SEARCH_SUCCESS";
export const PRODUCT_SEARCH_FAILED = "PRODUCT_SEARCH_FAILED";


/***  Related  Product List  */
export const RELATED_PRODUCTS = "RELATED_PRODUCTS";
export const RELATED_PRODUCTS_FAILED = "RELATED_PRODUCTS_FAILED";
export const RELATED_PRODUCTS_SUCCESS = "RELATED_PRODUCTS_SUCCESS";

/***  Related  Product List  */
export const PRODUCTS_BANNERS = "PRODUCTS_BANNERS";
export const PRODUCTS_BANNERS_FAILED = "PRODUCTS_BANNERS_FAILED";
export const PRODUCTS_BANNERS_SUCCESS = "PRODUCTS_BANNERS_SUCCESS";

/***  Related  Product List  */
export const PRODUCTS_SIZES = "PRODUCTS_SIZES";
export const PRODUCTS_SIZES_FAILED = "PRODUCTS_SIZES_FAILED";
export const PRODUCTS_SIZES_SUCCESS = "PRODUCTS_SIZES_SUCCESS";


